import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

type transactionDataType = {
  companyId: string;
  currency: string;
  showDeleted: boolean;
  tx_type?: string;
  errorCallback: Function;
  resultKey: string;
};

export default ({
  companyId,
  currency,
  errorCallback,
  resultKey = 'transactionsForAdjustingData',
}: transactionDataType) =>
  requestAsync({
    url: endpoints.getTransactionsForAdjustingUrl(companyId, currency),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getTransactionsForAdjustingUrl(companyId, currency),
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
